import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss']
})
export class ErrorComponent {

    constructor(private readonly location: Location, private readonly router: Router) { }

    public goBack() {
        this.location.back();
    }

    public goToLanding() {
        this.router.navigate(['home', '/']);
    }

}
